// TES-1030 — a flag in the transfer case view links to the question and
// answer that raised it, the pattern the patient overview's RiskFlagsPanel
// has for F-02 (TES-948). Kirill, admin run-through 2026-09-30.

export interface AnchoredSection {
  items: ReadonlyArray<{ key: string }>;
}

// The DOM id of one answer row in one form column. `scope` keeps the F-07
// and F-02 columns apart, since both render on the same page.
export function answerAnchorId(scope: string, fieldKey: string): string {
  return `svar-${scope}-${fieldKey.replace(/[^A-Za-z0-9_-]/g, "_")}`;
}

// The first of the flag's answer keys that the overview actually shows, or
// null when none is there (an unanswered follow-up, a rule with no keys). A
// flag without one is not rendered as a link: a link that goes nowhere is
// worse than none.
export function linkedAnswerKey(
  fieldKeys: readonly string[] | undefined,
  sections: readonly AnchoredSection[],
): string | null {
  if (!fieldKeys || fieldKeys.length === 0) return null;
  const shown = new Set(sections.flatMap((s) => s.items.map((i) => i.key)));
  return fieldKeys.find((k) => shown.has(k)) ?? null;
}
